// Only the highest-ranked goals are actively prioritised. Ranks run 1..N over
// that many goals; everything below the cutoff carries rank 0, which sorts it
// after the ranked ones.
export const TOP_PRIORITY_COUNT = 5;
